import { render, staticRenderFns } from "./PegawaiChart.vue?vue&type=template&id=58574311&scoped=true"
import script from "./PegawaiChart.vue?vue&type=script&lang=js"
export * from "./PegawaiChart.vue?vue&type=script&lang=js"
import style0 from "./PegawaiChart.vue?vue&type=style&index=0&id=58574311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58574311",
  null
  
)

export default component.exports